import { Outlet } from 'react-router-dom';
import { Auth0Required } from './auth-wrapper';
import { useAuth0Interceptor } from './auth0-interceptor';

export function Auth0RequiredLayout() {
  useAuth0Interceptor();
  return (
    <Auth0Required>
      <Outlet />
    </Auth0Required>
  );
}
